import { Bar, mixins } from 'vue-chartjs';
import globalOptionsMixin from "@/components/Charts/globalOptionsMixin";
  const horizonalLinePlugin = {
    id: 'horizontalLine',
    afterDraw: function(chartInstance) {
  
      var yValue;
      var yScale = chartInstance.scales["y-axis-0"];
      var canvas = chartInstance.chart;
      var ctx = canvas.ctx;
      var index;
      var line;
      var style;
  
      if (chartInstance.options.horizontalLine) {
  
        for (index = 0; index < chartInstance.options.horizontalLine.length; index++) {
          line = chartInstance.options.horizontalLine[index];
  
          if (!line.style) {
            style = "#080808";
          } else {
            style = line.style;
          }
  
          if (line.y) {
            yValue = yScale.getPixelForValue(line.y);
          } else {
            yValue = 0;
          }
          ctx.lineWidth = 3;
  
          if (yValue) {
            window.chart = chartInstance;
            ctx.beginPath();
            ctx.moveTo(0, yValue);
            ctx.lineTo(canvas.width, yValue);
            ctx.strokeStyle = style;
            ctx.stroke();
          }
  
          if (line.text) {
            ctx.fillStyle = style;
            ctx.fillText(line.text, 0, yValue + ctx.lineWidth);
          }
        }
        return;
      }
    }
  }
export default {
  name: 'bar-chart',
  extends: Bar,
  mixins: [mixins.reactiveProp, globalOptionsMixin],
  props: {
    extraOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ctx: null
    };
  },
  beforeMount () {
    this.addPlugin(horizonalLinePlugin)
  },
  mounted() {
    setTimeout(() => {
      this.$watch(
        'chartData',
        (newVal, oldVal) => {
          if (!oldVal) {
            this.renderChart(this.chartData,  {
              responsive: true, 
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: "right",
                fullWidth: true,
                labels: {
                  boxWidth: 8,
                  fontSize: 10
                }
             },
              scales: {
                xAxes: [{
                  categoryPercentage: 0.3,
                  barPercentage: 1
                }],
                yAxes: [{
                  ticks: {
                    stepSize: 10,
                    maxTicksLimit: 10
                 }
                }]
              }
            });
          }
        },
        { immediate: true }
      );
    }, 1000);
  }
};
